module.exports = __webpack_public_path__ + "img/icon-24-down.fc2d05c1.svg";